<template>
  <th>
    <v-text-field
      label=""
      clearable
      x-small
      fill-width
      class="d-flex justify-center font-weight-small text-center"
      style="font-size: 11px"
      @change="changed"
      v-model="targetID"
      single-line
    >
    </v-text-field>
  </th>
</template>

<script>
import { mapActions } from "vuex";

export default {
  props: {
    side: {
      type: String,
      default: "",
    },
  },
  data() {
    return {
      targetID: "",
    };
  },
  methods: {
    ...mapActions(["setFilterKey", "deleteFilterKey"]),
    changed: function () {
      // console.log("Changed:" + this.targetID);
      let key = "id";
      let key_to_delete = "id";
      let value = this.targetID;
      if (this.targetID == null) {
        this.deleteFilterKey({ key_to_delete: key_to_delete });
      } else {
        this.setFilterKey({ key, value });
      }
      this.$emit("filter_update");
    },
  },
};
</script>

<style scoped></style>
